import React, { Suspense, lazy } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '../../../ErrorBoundary';
import retry from '../../../utils/webpack/chunkRetry';
var CommentReduxModule = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "comment_redux2" */
        './CommentReduxModule');
    });
});
export var LoadableCommentReduxModule = function () {
    var isMounted = useIsMounted();
    if (!isMounted) {
        return null;
    }
    // prevent inside iframes
    if (typeof window !== 'undefined' && window.top !== window.self) {
        return null;
    }
    return (React.createElement(ErrorBoundary, { debugComponent: "LoadableCommentReduxModule" },
        React.createElement(Suspense, { fallback: null },
            React.createElement(CommentReduxModule, null))));
};
LoadableCommentReduxModule.displayName = 'LoadableCommentReduxModule';
export default LoadableCommentReduxModule;
//# sourceMappingURL=LoadableCommentReduxModule.js.map